export enum LoadOrderErrorCode {
    /** 订单状态不正确（返回拆分父订单或合并子订单） */
    ORDER_SPLIT_MERGE_STATE_INVALID = "ORDER_SPLIT_MERGE_STATE_INVALID",
    /** 合并订单没有子订单 */
    MERGE_ORDER_NO_CHILDREN = "MERGE_ORDER_NO_CHILDREN",
    /** 合并订单只有一个子订单 */
    MERGE_ORDER_SINGLE_CHILD = "MERGE_ORDER_SINGLE_CHILD",
    /** 合并订单数量与子订单数量总和不匹配 */
    MERGE_ORDER_QUANTITY_MISMATCH = "MERGE_ORDER_QUANTITY_MISMATCH",
    /** 合并订单商品数量和种类与子订单不匹配 */
    MERGE_ORDER_ITEM_SIZE_MISMATCH = "MERGE_ORDER_ITEM_SIZE_MISMATCH",
    /** 合并订单缺少子订单中的商品 */
    MERGE_ORDER_MISS_ITEM = "MERGE_ORDER_MISS_ITEM",
    /** 合并订单商品与子订单商品不匹配 */
    MERGE_ORDER_ITEM_MISMATCH = "MERGE_ORDER_ITEM_MISMATCH",
    /** 已发货订单中存在待发货商品 */
    SHIPPED_ORDER_HAS_PENDING_SHIP_ITEM = "SHIPPED_ORDER_HAS_PENDING_SHIP_ITEM",
    /** 订单商品数量与实际不匹配 */
    ORDER_QUANTITY_MISMATCH = "ORDER_QUANTITY_MISMATCH",
    /** 合并订单的子订单状态存在冲突 */
    MERGE_ORDER_CHILD_STATUS_CONFLICT = "MERGE_ORDER_CHILD_STATUS_CONFLICT",
    /** 合并订单中有重复的合并子订单 */
    MERGE_ORDER_CHILD_CONFLICT = "MERGE_ORDER_CHILD_CONFLICT",
    /** 订单商品状态存在冲突 */
    ORDER_ITEM_STATUS_CONFLICT = "ORDER_ITEM_STATUS_CONFLICT",
    /** 订单有重复的订单商品 */
    ORDER_ITEM_CONFLICT = "ORDER_ITEM_CONFLICT",
}

export default class LoadOrderError extends Error {
    constructor(public code: LoadOrderErrorCode, msg: string) {
        super(msg);
    }
}
